import React from 'react';
import PropTypes from 'prop-types';
import CreditCardImage from 'components/Payments/CreditCardImage';
import DefaultModal from 'components/Utils/DefaultModal';
import './style.scss';
import ProgressMessage from 'components/Utils/ProgressMessage';
import DefaultButton from 'components/Utils/NewDefaultButton';
import PatientAddCardModal from 'components/Payments/CreditCardScreen/PatientAddCardModal';
const NewCreditCard = React.lazy(() => import('components/Payments/NewCreditCard'));

const CreditCardScreenView = (props) => (
  <div className="credit-card-screen pay-wall-content column grow">
    {props.isPatient ? <PatientAddCardModal {...props} /> : <AddCardModal {...props} />}
    <div className="credit-cards column grow gap-2 mt-2 mx-auto">
      <ProgressMessage show={props.loading && props.creditCards.length === 0} topRight={true} />
      {(!props.loading || props.creditCards.length > 0) && (
        <>
          {props.creditCards.length > 0 && (
            <>
              <CreditCardImageList {...props} />
              {(props.showButtons || props.allowAdd) && (
                <DefaultButton
                  name="Add Credit Card"
                  icon="credit-card"
                  className="blue"
                  style={{ width: '100%' }}
                  onClick={() => props.openModal(true)}
                />
              )}
            </>
          )}
          <React.Suspense fallback={<ProgressMessage />}>
            {props.creditCards.length === 0 && <NewCreditCard {...props} />}
          </React.Suspense>
        </>
      )}
    </div>
  </div>
);

export const AddCardModal = (props) =>
  props.showModal && (
    <DefaultModal
      className="modal add-card-modal height-auto"
      key="event-details-modal"
      wrap={true}
      padding={true}
      title="Add new Credit Card"
      content={
        <React.Suspense fallback={<ProgressMessage />}>
          <NewCreditCard onSuccess={props.onAddSuccess} patient={props.patient} />
        </React.Suspense>
      }
      isOpen={props.showModal}
      onRequestClose={() => props.openModal(false)}
    />
  );

const CreditCardImageList = (props) =>
  (props.creditCards || []).map((card) => (
    <div className="credit-card-wrapper" key={card.id}>
      <CreditCardImage
        card={card}
        onChange={props.onChange}
        showButtons={props.showButtons}
        patient={props.patient}
      />
    </div>
  ));

CreditCardScreenView.propTypes = {
  patient: PropTypes.object.isRequired,
  isPatient: PropTypes.bool,
  showModal: PropTypes.bool,
  showButtons: PropTypes.bool,
  allowAdd: PropTypes.bool,
  creditCards: PropTypes.array,
  onAddSuccess: PropTypes.func,
  onChange: PropTypes.func,
  openModal: PropTypes.func,
  blueAddIcon: PropTypes.bool,
};

export default CreditCardScreenView;
